interface DeleteConfirmModalProps {
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function DeleteConfirmModal({
  isOpen,
  onCancel,
  onConfirm
}: DeleteConfirmModalProps) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" dir="rtl">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <div className="me-3">
              <h3 className="text-lg font-medium text-gray-900 font-hebrew">
                אישור מחיקת תורנות
              </h3>
            </div>
          </div>

          <div className="mb-6">
            <p className="text-gray-700 font-hebrew">
              האם אתה בטוח שברצונך למחוק את הרישום לתורנות?
            </p>
            <p className="text-sm text-gray-500 mt-2 font-hebrew">
              פעולה זו לא ניתנת לביטול. התורנות תהפוך לזמינה להרשמה מחדש.
            </p>
          </div>

          <div className="flex gap-3 justify-end">
            <button
              type="button"
              onClick={onCancel}
              className="px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-700 border border-gray-300 rounded-md hover:bg-gray-50 font-hebrew"
            >
              ביטול
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md font-hebrew"
            >
              מחק תורנות
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
